import React from "react";

import { AccountForm, Layout, LoadingAccountForm } from "../../components";
import { Center } from "../../components/ui";
import { useGetUserQuery } from "../../store/api/user.api";

import styles from "./index.module.css";

const SettingsPage = () => {
  const userQuery = useGetUserQuery("");

  return (
    <Layout>
      <Center>
        <div className={styles.container}>
          {userQuery.isSuccess ? (
            <AccountForm user={userQuery.data} />
          ) : (
            <LoadingAccountForm />
          )}
          {/* <PasswordForm/> */}
        </div>
      </Center>
    </Layout>
  );
};

export default SettingsPage;
